// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KzaT","comment":"styles_comment__24EpF"};